import { useState } from 'react';
import { FiMail, FiLogOut } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { resendVerification } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import styles from './EmailVerificationRequired.module.css';

const EmailVerificationRequired = () => {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleResend = async () => {
    setLoading(true);
    try {
      await resendVerification();
      setSent(true);
      toast.success('Verification email sent! Check your inbox.');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to resend. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.iconBox}>
          <FiMail size={32} />
        </div>
        <h2 className={styles.title}>Verify your email to continue</h2>
        <p className={styles.desc}>
          We sent a verification link to <strong>{user?.email}</strong>.<br />
          Click the link in that email to activate your account.
        </p>

        <div className={styles.steps}>
          <div className={styles.step}><span>1</span> Check your inbox (and spam folder)</div>
          <div className={styles.step}><span>2</span> Click the verification link</div>
          <div className={styles.step}><span>3</span> Come back and refresh this page</div>
        </div>

        {sent && (
          <div className={styles.successMsg}>
            Email sent! If you don't see it within a few minutes, check your spam folder.
          </div>
        )}

        <div className={styles.actions}>
          <button className={styles.btnPrimary} onClick={handleResend} disabled={loading || sent}>
            <FiMail size={15} />
            {loading ? 'Sending…' : sent ? 'Email sent' : 'Resend verification email'}
          </button>
          <button className={styles.btnLogout} onClick={logout}>
            <FiLogOut size={14} /> Sign out
          </button>
        </div>

        <p className={styles.hint}>
          Once verified, refresh this page or sign in again.
        </p>
      </div>
    </div>
  );
};

export default EmailVerificationRequired;
